<template>
  <v-container class="pa-0" fluid>
    <v-row no-gutters>
      <v-col class>
        <section
          id="hero"
          v-if="(webPropio.home && webPropio.home.seccion1 && webPropio.home.seccion1.mostrar)"
        >
          <v-row no-gutters>
            <v-img
              max-height="250px"
              :src="imagenAleatoria"
              :lazy-src="imagenAleatoria"
              :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
              alt="Pide comida a domicilio"
            >
              <v-theme-provider
                style="background-image: linear-gradient(to right, rgba(5, 11, 31, 0.6), rgba(5, 11, 31, 0.6))"
                dark
              >
                <v-container fill-height class="pa-0" fluid>
                  <v-row align="center" class="white--text mx-auto pa-6" justify="center">
                    <v-col class="text-center">
                      <div
                        class="text-h6 text-md-h4 pb-12 mt-n16 font-weight-bold text-uppercase"
                      >¡Haz tu pedido ahora!</div>
                    </v-col>
                    <v-col class="white--text text-center pb-16" cols="12" tag="h1">
                      <v-btn
                        class="ma-4 font-weight-bold black--text border"
                        @click="$router.push('/pedir/domicilio')"
                        style="min-width:240px"
                        x-large
                        color="white"
                      >A domicilio</v-btn>
                      <v-btn
                        class="ma-4 font-weight-bold black--text border"
                        @click="$router.push('/pedir/recoger')"
                        style="min-width:240px"
                        x-large
                        color="white"
                      >A Recoger</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-theme-provider>
            </v-img>
          </v-row>
        </section>

        <section
          id="app"
          class="amber accent-2"
          v-if="(webPropio.home && webPropio.home.seccion2 && webPropio.home.seccion2.mostrar)"
        >
          <v-container class="fill-height">
            <v-row justify="center" align="center">
              <v-col class="d-flex justify-center" cols="12" sm="4">
                <div>
                  <v-img
                    class
                    :src="(webPropio.home.seccion2 && webPropio.home.seccion2.imagenMovilApp) ? webPropio.home.seccion2.imagenMovilApp : ''"
                    :lazy-src="(webPropio.home.seccion2 && webPropio.home.seccion2.imagenMovilApp) ? webPropio.home.seccion2.imagenMovilApp : ''"
                    width="200"
                  ></v-img>
                </div>
              </v-col>
              <v-col class cols="12" sm="4">
                <div class="pa-0">
                  <h2 class="text-center headline font-weight-bold black--text">Descarga nuestra App</h2>
                  <h2
                    class="text-center title font-weight-light mb-3 black--text"
                  >Disfruta de nuestras promociones</h2>
                </div>
                <div>
                  <div class="d-flex flex-wrap justify-center pa-0">
                    <v-img
                      class="ma-2"
                      src="/padthaiwok/logoAndroid.svg"
                      lazy-src="/padthaiwok/logoAndroid.svg"
                      width="136"
                      max-width="136"
                      height="40"
                      max-height="40"
                    ></v-img>

                    <v-img
                      class="ma-2"
                      src="/padthaiwok/logoIos.svg"
                      lazy-src="/padthaiwok/logoIos.svg"
                      width="136"
                      max-width="136"
                      height="40"
                      max-height="40"
                    ></v-img>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <!-- 
        <iframe
          src="https://www.google.com/maps/d/embed?mid=z2G9ZKcQsrIQ.kaT5UrqYJOHI"
          frameborder="0"
          width="100%"
          height="480"
          style="border: 0;"
          class
        ></iframe>-->

        <section
          id="franquicia"
          v-if="(webPropio.home.seccion3 && webPropio.home.seccion3.mostrar) "
        >
          <div class="py-12"></div>

          <v-container class="text-center">
            <h2
              class="display-2 font-weight-bold mb-3"
            >{{(webPropio.home.seccion3 && webPropio.home.seccion3.titulo) ? webPropio.home.seccion3.titulo : '' }}</h2>

            <v-responsive class="mx-auto mb-8" width="56">
              <v-divider class="mb-1"></v-divider>

              <v-divider></v-divider>
            </v-responsive>

            <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720"></v-responsive>
            <v-responsive class="mx-auto title font-weight-light mb-8">
              <v-img
                :src="(webPropio.home.seccion3 && webPropio.home.seccion3.imagen) ? webPropio.home.seccion3.imagen : '' "
                :lazy-src="(webPropio.home.seccion3 && webPropio.home.seccion3.imagen) ? webPropio.home.seccion3.imagen : '' "
              ></v-img>
            </v-responsive>
            <div
              v-html="(webPropio.home.seccion3 && webPropio.home.seccion3.texto) ? webPropio.home.seccion3.texto : '' "
            />
            <v-btn color="grey" href="#" outlined large>
              <span class="grey--text text--darken-1 font-weight-bold">Contactar</span>
            </v-btn>
          </v-container>

          <div class="py-12"></div>
        </section>

        <v-sheet id="contact" tag="section" tile>
          <div class="py-12"></div>

          <v-container>
            <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contacto</h2>

            <v-responsive class="mx-auto mb-12" width="56">
              <v-divider class="mb-1"></v-divider>

              <v-divider></v-divider>
            </v-responsive>

            <v-theme-provider>
              <v-row class="mx-auto" style="max-width:600px">
                <v-col cols="12">
                  <v-text-field
                    v-model="form.nombre"
                    dense
                    outlined
                    label="Nombre*"
                    solo
                    :error-messages="nombreErrors"
                    @input="$v.form.nombre.$touch()"
                    @blur="$v.form.nombre.$touch()"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.email"
                    dense
                    outlined
                    label="Email*"
                    solo
                    :error-messages="emailErrors"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="form.restaurante"
                    :items="restaurantesForm"
                    outlined
                    dense
                    solo
                    chips
                    small-chips
                    label="Seleccione restaurante*"
                    multiple
                    :error-messages="restauranteErrors"
                    @input="$v.form.restaurante.$touch()"
                    @blur="$v.form.restaurante.$touch()"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="form.mensaje"
                    outlined
                    label="Mensaje*"
                    solo
                    :error-messages="mensajeErrors"
                    @input="$v.form.mensaje.$touch()"
                    @blur="$v.form.mensaje.$touch()"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-btn block color x-large :loading="form.loadingEnviar" @click="sendEmail">Enviar</v-btn>
                </v-col>
              </v-row>
            </v-theme-provider>
          </v-container>

          <div class="py-12"></div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const { VUE_APP_MODE, VUE_APP_PLATFORM } = process.env;
import { validationMixin } from "vuelidate";
import { mapGetters, mapState } from "vuex";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "home",
  mixins: [validationMixin],
  validations: {
    form: {
      email: { required, email },
      nombre: { required },
      restaurante: { required },
      mensaje: { required, minLength: minLength(8) }
    }
  },
  data() {
    return {
      form: {
        nombre: "",
        email: "",
        restaurante: [],
        mensaje: "",
        loadingEnviar: false
      },
      mostrarFlechas: false,
      navbarTitle: `Home.vue`,
      msg: `Mode=${VUE_APP_MODE} and Platform=${VUE_APP_PLATFORM}`,
      items: []
    };
  },
  metaInfo() {
    return {
      title: this.webPropio.home.seo.title,
      //titleTemplate: this.webPropio.general.seo.titleTemplate,
      meta: [
        { name: "description", content: this.webPropio.home.seo.description }
        /*{
          property: "og:title",
          content: "Cervecería el Pikoteo"
        },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" }*/
      ]
    };
  },
  computed: {
    imagenAleatoria() {
      if (Array.isArray(this.items && this.items[0])) console.log(this.items);
      let random = Math.floor(Math.random() * this.items.length);
      console.log(random);
      return Array.isArray(this.items) && this.items[random]
        ? this.items[random].src
        : "";
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.form.nombre.$dirty) return errors;
      !this.$v.form.nombre.required && errors.push("Nombre obligatorio");
      return errors;
    },
    restauranteErrors() {
      const errors = [];
      if (!this.$v.form.restaurante.$dirty) return errors;
      !this.$v.form.restaurante.required &&
        errors.push("Restaurante obligatorio.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.email && errors.push("Email no correcto");
      !this.$v.form.email.required && errors.push("E-mail obligatorio");
      return errors;
    },
    mensajeErrors() {
      const errors = [];
      if (!this.$v.form.mensaje.$dirty) return errors;
      !this.$v.form.mensaje.required && errors.push("Mensaje requerido");
      !this.$v.form.mensaje.minLength && errors.push("Demasiado corto.");
      return errors;
    },
    ...mapGetters({
      restaurantesForm: "restaurante/listadoRestauranteFormContacto"
    }),
    ...mapState({
      webPropio: state => state.propio.negocioPropioObj.web
    })
  },
  methods: {
    sendEmail() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const _vm = this;
        _vm.form.loadingEnviar = true;
        this.$recaptcha("formulario")
          .then(r => {
            this.form.captcha = r;
            return this.$store.dispatch("app/sendFormContacto", this.form);
          })
          .then(r => {
            console.log(r);
            if (r.data.ok) {
              this.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Mensaje enviado correctamente."
              });
            } else {
              this.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al enviar el mensaje: " + r.data.error
              });
            }

            /*this.form = {
              nombre: "",
              email: "",
              msj: "",
              restaurante: []
            };*/
            this.$v.$reset();
          })
          .catch(e => {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al enviar el mensaje. " + e
            });
          })
          .finally(() => (_vm.form.loadingEnviar = false));
      }
    }
  },
  mounted() {
    if (this.webPropio.home.seccion1.slider) {
      var aux = [];
      const v = Object.values(this.webPropio.home.seccion1.slider);
      console.log(v);
      v.forEach(e => {
        if (e && e.length > 0) {
          aux.push({
            src: e
          });
        }
      });
      if (aux.length > 1) this.mostrarFlechas = true;
    }
    this.items = aux;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border {
  border: 1px solid #000;
}
.bgtransparent {
  background-color: rgb(0, 0, 0, 0.22);
}
.sombra {
  -webkit-box-shadow: 3px 6px 12px 1px rgba(84, 84, 84, 1);
  -moz-box-shadow: 3px 6px 12px 1px rgba(84, 84, 84, 1);
  box-shadow: 3px 6px 12px 1px rgba(84, 84, 84, 1);
}
</style>
